import React from "react";
import PeriodSelector from '../periodSelector';
import FiltersWrapper from '../wrappers/filtersWrapper';
import DimensionSelector from '../dimensionSelector';
import FilterBySelector from '../filterBySelector';
import ActionTypes from "../../stateManagement/actions/types";
import SplitDateSwitch from "../splitDateSwitch";
import IsDealSwitch from "../isDealSwitch";
import { PARTITION_THD, PARTITION_MAIN } from "../../utils/constants";
import { useLocation } from "react-router-dom";

const dimensions_1_thd = [
    { label: 'Platform', value: 'provider', key: '1' },
    { label: 'Publisher', value: 'publisher', key: '2' },
    { label: 'Website', value: 'website', key: '3' },
];

const dimensions_2_thd = [
    { label: 'No dimension', value: '', key: '0' },
    { label: 'Channel', value: 'label', key: '1'},
    { label: 'Platform', value: 'provider', key: '2' },
    { label: 'Publisher', value: 'publisher', key: '3' },
    { label: 'Website', value: 'website', key: '4' },
    { label: 'Line item type', value: 'lineItemType', key: '5' },
    { label: 'Deal name', value: 'dealName', key: '6' },
    { label: 'Order name', value: 'orderName', key: '7' },
    { label: 'Advertiser', value: 'orderAdvertiser', key: '8' },
];

const dimensions_3_thd = [
    { label: 'No dimension', value: '', key: '0' },
    { label: 'Channel', value: 'label', key: '1'},
    { label: 'Platform', value: 'provider', key: '2' },
    { label: 'Publisher', value: 'publisher', key: '3' },
    { label: 'Website', value: 'website', key: '4' },
    { label: 'Line item type', value: 'lineItemType', key: '5' },
    { label: 'Deal name', value: 'dealName', key: '6' },
    { label: 'Order name', value: 'orderName', key: '7' },
    { label: 'Advertiser', value: 'orderAdvertiser', key: '8' },
    { label: 'Media type', value: 'mediaType', key: '9' },
];

const dimensions_1_main = [
    { label: 'Platform', value: 'provider', key: '1' },
    { label: 'Publisher', value: 'publisher', key: '2' },
    { label: 'Website', value: 'website', key: '3' },
];

const dimensions_2_main = [
    { label: 'No dimension', value: '', key: '0' },
    { label: 'Platform', value: 'provider', key: '1' },
    { label: 'Publisher', value: 'publisher', key: '2' },
    { label: 'Website', value: 'website', key: '3' },
    { label: 'Placement', value: 'placementFormat', key: '4' },
    { label: 'Media type', value: 'mediaType', key: '5' },
    { label: 'Auction type', value: 'auctionType', key: '6' },
    { label: 'Deal name', value: 'dealName', key: '7' },
];

const dimensions_3_main = [
    { label: 'No dimension', value: '', key: '0' },
    { label: 'Platform', value: 'provider', key: '1' },
    { label: 'Publisher', value: 'publisher', key: '2' },
    { label: 'Website', value: 'website', key: '3' },
    { label: 'Placement', value: 'placementFormat', key: '4' },
    { label: 'Media type', value: 'mediaType', key: '5' },
    { label: 'Auction type', value: 'auctionType', key: '6' },
];

const ReportFiltersSection = () => {

    const location = useLocation();
    const PARTITION = location.pathname.includes(PARTITION_THD) ? PARTITION_THD : PARTITION_MAIN;
    
    const DIMENSION_1 = PARTITION === PARTITION_THD ? dimensions_1_thd : dimensions_1_main;
    const DIMENSION_2 = PARTITION === PARTITION_THD ? dimensions_2_thd : dimensions_2_main;
    const DIMENSION_3 = PARTITION === PARTITION_THD ? dimensions_3_thd : dimensions_3_main;

  return (<>
      <FiltersWrapper label="Selected period:">
        <PeriodSelector />
        <SplitDateSwitch />
      </FiltersWrapper>
      <FiltersWrapper label="Filter by:">
          <FilterBySelector />
      </FiltersWrapper>
      <IsDealSwitch />
      <FiltersWrapper label="First dimension:">
          <DimensionSelector dimensions={DIMENSION_1} dimensionType={ActionTypes.R_CHANGE_DIMENSION_1}/>
      </FiltersWrapper>
      <FiltersWrapper label="Second dimension:">
          <DimensionSelector dimensions={DIMENSION_2} dimensionType={ActionTypes.R_CHANGE_DIMENSION_2}/>
      </FiltersWrapper>
      <FiltersWrapper label="Third dimension:">
          <DimensionSelector dimensions={DIMENSION_3} dimensionType={ActionTypes.R_CHANGE_DIMENSION_3}/>
      </FiltersWrapper>
  </>);
};

export default ReportFiltersSection;